import { c as _c } from "react/compiler-runtime";
import { FileDropZone, fileInputAcceptTypes } from '@systemeio/file-manager';
import { FormSelect } from '@systemeio/ui';
import { useCampaignsList } from 'modules/campaigns/hooks/use-campaigns-list';
import { CampaignId } from 'modules/campaigns/types/campaign-interface';
import ContactSelectTags from 'modules/contacts/contact-page/components/contact-select-tags';
import LastContactsImportsTable from 'modules/contacts/contacts-import/components/last-contacts-imports-table';
import { SelectColumnsForContactsImportModal } from 'modules/contacts/contacts-import/components/select-columns-for-contacts-import-modal';
import { ContactsImportPageLoco } from 'modules/contacts/contacts-import/constants/contacts-import-page-loco';
import { ContactsImportDelimiter, getContactsImportDelimiterSelectOptions } from 'modules/contacts/contacts-import/types/contacts-import-delimeter-type';
import { ContactsLastImportsApiInterface } from 'modules/contacts/contacts-import/types/contacts-import-interface';
import { ContactBulkApiInterface } from 'modules/contacts/types/contact-menu-interface';
import { CreateNewTagModal } from 'modules/tags/components/create-new-tag-modal';
import { NextPage } from 'next';
import { useMemo, useRef, useState } from 'react';
import { InfoBlockOrderedListItem } from 'shared/components/info-block-ordered-list-item';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
import { KeyedMutator } from 'swr';
import { CheckCircleIcon, InfoIcon, QuestionMarkIcon } from '@systemeio/ui/icons';
import { ContactImportWarning } from 'modules/contacts/contacts-import/components/contact-import-warning';
const ContactEdit: NextPage = () => {
  const $ = _c(184);
  const {
    t
  } = useLocoTranslation();
  const lastContactsImportsTableRef = useRef(null);
  const mutateLastContactsImportsTable = useRef(null);
  const [file, setFile] = useState(null);
  const [delimiter, setDelimiter] = useState(ContactsImportDelimiter.comma);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [selectedTags, setSelectedTags] = useState(t0);
  const [selectedCampaignId, setSelectedCampaignId] = useState();
  const {
    campaignsList
  } = useCampaignsList();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t1;
  if ($[1] !== campaignsList?.items) {
    t1 = campaignsList?.items.map(_temp);
    $[1] = campaignsList?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const campaignsListOptions = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setSelectedCampaignId(undefined);
      setSelectedTags([]);
      setDelimiter(ContactsImportDelimiter.comma);
      setFile(null);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const clearStates = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = mutate => {
      mutateLastContactsImportsTable.current = mutate;
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setMutateLastContactsImports = t3;
  let t4;
  if ($[5] !== t) {
    t4 = getContactsImportDelimiterSelectOptions(t);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const contactsImportDelimiterSelectOptions = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ContactImportWarning />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <QuestionMarkIcon className="fill-brand-primary mr-2 inline h-[20px] w-[20px]" />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("dashboard.contact_import.instruction.title");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <h3 className="mb-4 text-[18px] leading-6">{t6}{t7}</h3>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t) {
    t9 = t("dashboard.contact_import.instruction.first");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t9
    }} />;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t) {
    t11 = t("dashboard.contact_import.instruction.second");
    $[17] = t;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t11
    }} />;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t) {
    t13 = t("dashboard.contact_import.instruction.third");
    $[21] = t;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13) {
    t14 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t13
    }} />;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t("dashboard.contact_import.instruction.fourth");
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t15
    }} />;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t) {
    t17 = t("dashboard.contact_import.instruction.fifth");
    $[29] = t;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  let t18;
  if ($[31] !== t17) {
    t18 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t17
    }} />;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t) {
    t19 = t("dashboard.contact_import.instruction.subparagraph_first");
    $[33] = t;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t19) {
    t20 = <li className="mb-2">{t19}</li>;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t) {
    t21 = t("dashboard.contact_import.instruction.subparagraph_second");
    $[37] = t;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t21) {
    t22 = <li>{t21}</li>;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t20 || $[42] !== t22) {
    t23 = <ul className="list-disc pl-14">{t20}{t22}</ul>;
    $[41] = t20;
    $[42] = t22;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== t) {
    t24 = t("dashboard.contact_import.instruction.sixth");
    $[44] = t;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t24) {
    t25 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t24
    }} />;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t10 || $[49] !== t12 || $[50] !== t14 || $[51] !== t16 || $[52] !== t18 || $[53] !== t23 || $[54] !== t25) {
    t26 = <ul className="flex flex-col gap-6">{t10}{t12}{t14}{t16}{t18}{t23}{t25}</ul>;
    $[48] = t10;
    $[49] = t12;
    $[50] = t14;
    $[51] = t16;
    $[52] = t18;
    $[53] = t23;
    $[54] = t25;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== t) {
    t27 = t("dashboard.contact_import.instruction_popup.title");
    $[56] = t;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t27) {
    t28 = <span className="text-text-primary text-[16px] font-bold leading-6">{t27}</span>;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== t) {
    t29 = t("dashboard.contact_import.instruction_popup.first");
    $[60] = t;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] !== t29) {
    t30 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t29
    }} />;
    $[62] = t29;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t) {
    t31 = t("dashboard.contact_import.instruction_popup.second");
    $[64] = t;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t31) {
    t32 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t31
    }} />;
    $[66] = t31;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] !== t) {
    t33 = t("dashboard.contact_import.instruction_popup.third");
    $[68] = t;
    $[69] = t33;
  } else {
    t33 = $[69];
  }
  let t34;
  if ($[70] !== t33) {
    t34 = <InfoBlockOrderedListItem dangerouslySetInnerHTML={{
      __html: t33
    }} />;
    $[70] = t33;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  let t35;
  if ($[72] !== t30 || $[73] !== t32 || $[74] !== t34) {
    t35 = <ul className="flex flex-col gap-6">{t30}{t32}{t34}</ul>;
    $[72] = t30;
    $[73] = t32;
    $[74] = t34;
    $[75] = t35;
  } else {
    t35 = $[75];
  }
  let t36;
  if ($[76] !== t26 || $[77] !== t28 || $[78] !== t35 || $[79] !== t8) {
    t36 = <div className={"bg-background-secondary flex h-fit flex-col gap-6\n        rounded-md p-6\n        xl:col-start-2 xl:row-start-1 xl:row-end-7"}>{t8}{t26}{t28}{t35}</div>;
    $[76] = t26;
    $[77] = t28;
    $[78] = t35;
    $[79] = t8;
    $[80] = t36;
  } else {
    t36 = $[80];
  }
  let t37;
  if ($[81] !== t) {
    t37 = t("dashboard.contact_import.import_file_block.title");
    $[81] = t;
    $[82] = t37;
  } else {
    t37 = $[82];
  }
  let t38;
  if ($[83] !== file) {
    t38 = file && <CheckCircleIcon className="fill-green h-[20px] w-[20px]" />;
    $[83] = file;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== t37 || $[86] !== t38) {
    t39 = <h1 className="mb-6 flex gap-2 self-start text-[17px] lg:self-center">{t37}{t38}</h1>;
    $[85] = t37;
    $[86] = t38;
    $[87] = t39;
  } else {
    t39 = $[87];
  }
  let t40;
  if ($[88] !== t) {
    t40 = t("dashboard.contact_import.form.label.delimiter");
    $[88] = t;
    $[89] = t40;
  } else {
    t40 = $[89];
  }
  let t41;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = data => data && setDelimiter(data);
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== contactsImportDelimiterSelectOptions || $[92] !== delimiter || $[93] !== t40) {
    t42 = <div className="flex grow basis-[300px] flex-col gap-9"><FormSelect withoutCloseIcon={true} label={t40} data={contactsImportDelimiterSelectOptions} value={delimiter} onChange={t41} /></div>;
    $[91] = contactsImportDelimiterSelectOptions;
    $[92] = delimiter;
    $[93] = t40;
    $[94] = t42;
  } else {
    t42 = $[94];
  }
  let t43;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = files => {
      const file_0 = files[0];
      if (!file_0) {
        return;
      }
      setFile(file_0);
    };
    $[95] = t43;
  } else {
    t43 = $[95];
  }
  let t44;
  if ($[96] !== file || $[97] !== t) {
    t44 = <>{file ? <p>{file.name}</p> : <p>{t("dashboard.contact_import.form.label.import-file.title")}</p>}</>;
    $[96] = file;
    $[97] = t;
    $[98] = t44;
  } else {
    t44 = $[98];
  }
  let t45;
  if ($[99] !== t) {
    t45 = t("dashboard.contact_import.form.toast.file_upload_complete");
    $[99] = t;
    $[100] = t45;
  } else {
    t45 = $[100];
  }
  let t46;
  if ($[101] !== t44 || $[102] !== t45) {
    t46 = <FileDropZone acceptTypes={fileInputAcceptTypes.csv} className="grow basis-40 md:shrink-0" dropZoneClassName="h-full" onSelect={t43} label={t44} toastText={t45} />;
    $[101] = t44;
    $[102] = t45;
    $[103] = t46;
  } else {
    t46 = $[103];
  }
  let t47;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = <InfoIcon className="fill-brand-primary mr-2 inline" />;
    $[104] = t47;
  } else {
    t47 = $[104];
  }
  let t48;
  if ($[105] !== t) {
    t48 = t("dashboard.contact_import.form.label.import-file.info");
    $[105] = t;
    $[106] = t48;
  } else {
    t48 = $[106];
  }
  let t49;
  if ($[107] !== t48) {
    t49 = <p className="flex items-center">{t47}{t48}</p>;
    $[107] = t48;
    $[108] = t49;
  } else {
    t49 = $[108];
  }
  let t50;
  if ($[109] !== t46 || $[110] !== t49) {
    t50 = <div className="flex flex-col gap-3.5">{t46}{t49}</div>;
    $[109] = t46;
    $[110] = t49;
    $[111] = t50;
  } else {
    t50 = $[111];
  }
  let t51;
  if ($[112] !== t42 || $[113] !== t50) {
    t51 = <div className="flex flex-wrap gap-7">{t42}{t50}</div>;
    $[112] = t42;
    $[113] = t50;
    $[114] = t51;
  } else {
    t51 = $[114];
  }
  let t52;
  if ($[115] !== t39 || $[116] !== t51) {
    t52 = <div className="bg-background-secondary rounded-md p-6">{t39}{t51}</div>;
    $[115] = t39;
    $[116] = t51;
    $[117] = t52;
  } else {
    t52 = $[117];
  }
  let t53;
  if ($[118] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = () => setSelectedTags([]);
    $[118] = t53;
  } else {
    t53 = $[118];
  }
  let t54;
  if ($[119] !== revalidateModules) {
    t54 = <CreateNewTagModal onCreate={async () => {
      await revalidateModules([RequestModuleEnum.Tags]);
    }} />;
    $[119] = revalidateModules;
    $[120] = t54;
  } else {
    t54 = $[120];
  }
  let t55;
  if ($[121] !== selectedTags || $[122] !== t54) {
    t55 = <ContactSelectTags className="bg-background-secondary rounded-lg p-6 xl:col-start-1" tempTags={selectedTags} setTempTags={setSelectedTags} resetTags={t53} additionalButtonBarComponent={t54} />;
    $[121] = selectedTags;
    $[122] = t54;
    $[123] = t55;
  } else {
    t55 = $[123];
  }
  let t56;
  if ($[124] !== t) {
    t56 = t("dashboard.contact_import.campaign_title");
    $[124] = t;
    $[125] = t56;
  } else {
    t56 = $[125];
  }
  let t57;
  if ($[126] !== t56) {
    t57 = <h1 className="mb-2 self-start text-[17px] lg:self-center">{t56}</h1>;
    $[126] = t56;
    $[127] = t57;
  } else {
    t57 = $[127];
  }
  let t58;
  if ($[128] !== t) {
    t58 = t("dashboard.contact_import.form.label.campaign");
    $[128] = t;
    $[129] = t58;
  } else {
    t58 = $[129];
  }
  let t59;
  if ($[130] !== t58) {
    t59 = <span>{t58}</span>;
    $[130] = t58;
    $[131] = t59;
  } else {
    t59 = $[131];
  }
  let t60;
  if ($[132] !== t57 || $[133] !== t59) {
    t60 = <div className="mb-6">{t57}{t59}</div>;
    $[132] = t57;
    $[133] = t59;
    $[134] = t60;
  } else {
    t60 = $[134];
  }
  const t61 = !campaignsList;
  let t62;
  if ($[135] !== campaignsListOptions || $[136] !== selectedCampaignId || $[137] !== t61) {
    t62 = <div className="flex flex-wrap gap-7"><div className="flex grow basis-[300px] flex-col gap-9"><FormSelect isPreFetching={t61} data={campaignsListOptions} value={selectedCampaignId} onChange={setSelectedCampaignId} /></div></div>;
    $[135] = campaignsListOptions;
    $[136] = selectedCampaignId;
    $[137] = t61;
    $[138] = t62;
  } else {
    t62 = $[138];
  }
  let t63;
  if ($[139] !== t60 || $[140] !== t62) {
    t63 = <div className="flex flex-1 flex-col">{t60}{t62}</div>;
    $[139] = t60;
    $[140] = t62;
    $[141] = t63;
  } else {
    t63 = $[141];
  }
  let t64;
  if ($[142] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = <QuestionMarkIcon className="fill-brand-primary inline h-[16px] w-[16px]" />;
    $[142] = t64;
  } else {
    t64 = $[142];
  }
  let t65;
  if ($[143] !== t) {
    t65 = t("dashboard.contact_import.campaign_instruction.title");
    $[143] = t;
    $[144] = t65;
  } else {
    t65 = $[144];
  }
  let t66;
  if ($[145] !== t65) {
    t66 = <div className="mb-10 flex items-center gap-3">{t64}<span className="text-text-primary text-base font-bold">{t65}</span></div>;
    $[145] = t65;
    $[146] = t66;
  } else {
    t66 = $[146];
  }
  let t67;
  if ($[147] !== t) {
    t67 = t("dashboard.contact_import.campaign_instruction.first");
    $[147] = t;
    $[148] = t67;
  } else {
    t67 = $[148];
  }
  let t68;
  if ($[149] !== t67) {
    t68 = <span dangerouslySetInnerHTML={{
      __html: t67
    }} />;
    $[149] = t67;
    $[150] = t68;
  } else {
    t68 = $[150];
  }
  let t69;
  if ($[151] !== t) {
    t69 = t("dashboard.contact_import.campaign_instruction.second");
    $[151] = t;
    $[152] = t69;
  } else {
    t69 = $[152];
  }
  let t70;
  if ($[153] !== t69) {
    t70 = <li className="mb-2">{t69}</li>;
    $[153] = t69;
    $[154] = t70;
  } else {
    t70 = $[154];
  }
  let t71;
  if ($[155] !== t) {
    t71 = t("dashboard.contact_import.campaign_instruction.third");
    $[155] = t;
    $[156] = t71;
  } else {
    t71 = $[156];
  }
  let t72;
  if ($[157] !== t71) {
    t72 = <li>{t71}</li>;
    $[157] = t71;
    $[158] = t72;
  } else {
    t72 = $[158];
  }
  let t73;
  if ($[159] !== t70 || $[160] !== t72) {
    t73 = <ul className="mt-3 list-disc pl-3.5">{t70}{t72}</ul>;
    $[159] = t70;
    $[160] = t72;
    $[161] = t73;
  } else {
    t73 = $[161];
  }
  let t74;
  if ($[162] !== t68 || $[163] !== t73) {
    t74 = <div>{t68}{t73}</div>;
    $[162] = t68;
    $[163] = t73;
    $[164] = t74;
  } else {
    t74 = $[164];
  }
  let t75;
  if ($[165] !== t66 || $[166] !== t74) {
    t75 = <div className="sm:max-w-[340px]"><div className="border-text-secondary/30 rounded-lg border p-6">{t66}{t74}</div></div>;
    $[165] = t66;
    $[166] = t74;
    $[167] = t75;
  } else {
    t75 = $[167];
  }
  let t76;
  if ($[168] !== t63 || $[169] !== t75) {
    t76 = <div className="bg-background-secondary flex flex-wrap gap-8 rounded-md p-6 lg:self-center">{t63}{t75}</div>;
    $[168] = t63;
    $[169] = t75;
    $[170] = t76;
  } else {
    t76 = $[170];
  }
  let t77;
  if ($[171] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = async () => {
      mutateLastContactsImportsTable.current && (await mutateLastContactsImportsTable.current());
    };
    $[171] = t77;
  } else {
    t77 = $[171];
  }
  let t78;
  if ($[172] !== delimiter || $[173] !== file || $[174] !== selectedCampaignId || $[175] !== selectedTags) {
    t78 = <div className="flex justify-center"><SelectColumnsForContactsImportModal file={file} delimiter={delimiter} campaign={selectedCampaignId} tags={selectedTags} onConfirm={t77} clearStates={clearStates} /></div>;
    $[172] = delimiter;
    $[173] = file;
    $[174] = selectedCampaignId;
    $[175] = selectedTags;
    $[176] = t78;
  } else {
    t78 = $[176];
  }
  let t79;
  if ($[177] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <LastContactsImportsTable ref={lastContactsImportsTableRef} className="rounded-lg lg:col-start-1" setMutateLastContactsImports={setMutateLastContactsImports} />;
    $[177] = t79;
  } else {
    t79 = $[177];
  }
  let t80;
  if ($[178] !== t36 || $[179] !== t52 || $[180] !== t55 || $[181] !== t76 || $[182] !== t78) {
    t80 = <div className="grid gap-6 lg:gap-11 xl:grid-cols-[1fr_485px]">{t5}{t36}{t52}{t55}{t76}{t78}{t79}</div>;
    $[178] = t36;
    $[179] = t52;
    $[180] = t55;
    $[181] = t76;
    $[182] = t78;
    $[183] = t80;
  } else {
    t80 = $[183];
  }
  return t80;
};
export const getServerSideProps = getBaseServerSideProps(ContactsImportPageLoco, 'header.top_menu.contacts');
export default ContactEdit;
function _temp(t0) {
  const {
    id,
    name
  } = t0;
  return {
    id,
    caption: name
  };
}